
import {createIntl} from '@formatjs/intl'


export var intl = createIntl({
    locale: 'pl',
    defaultLocale: 'pl',
    messages: {
        'test': 'sukces',
        'childAgePlural': 'dziecko w wieku {age, plural, one{roku}, other{lat}}',
        'childrenAgesPlural': '{count} dzieci w wieku {ages} lat'
    }
});
let translationsLoaded = false;
var translationsLoadedPromiseResolve = () => {};
export var translationsLoadedPromise = new Promise<void>((resolve,reject) => {
    translationsLoadedPromiseResolve = resolve;
});
export function areTranslationsLoaded() {
    return translationsLoaded;
}
export function loadTranslations(translations:object) {
    if(translationsLoaded) {
        return;
    }
    for(let key in translations) {
        //@ts-ignore
        intl.messages[key] = translations[key];
    }
    translationsLoaded = true;
    translationsLoadedPromiseResolve();
}
export function resetTranslations() {
    translationsLoaded = false;
    translationsLoadedPromise = new Promise<void>((resolve,reject) => {
        translationsLoadedPromiseResolve = resolve;
    });
}

/**
 * Specjalny typ, żeby wymusić używanie przetłumaczonych tekstów w kodzie
 */
export class translatedString extends String {
    public translated: boolean = true;
};

/**
 * Zwraca przetłumaczony tekst
 * @param translationKey klucz po którym zostanie znalezione tłumaczenie
 * @param translationValues obiekt z wartościami do podstawienia w tłumaczeniu
 */
export function  getTranslation(translationKey: string, translationValues: object|null = null):translatedString  {
    return new translatedString(intl.formatMessage({id: translationKey, defaultMessage: translationKey}, <any>translationValues));
}

